module.exports = __webpack_public_path__ + "assets/img/logo3.825e97b6.png";